import React, { useEffect, useState } from "react";
import { connect } from "react-redux";

import { IonContent, IonItem, IonLabel, IonList } from "@ionic/react";
import AppHeader from "components/Header/AppHeader";
import AddTeamModal from "./AddTeamModal";
import EditTeamModal from "./EditTeamModal";
import { getTeams, clearTeams } from "services/teams";
import { setLoading } from "services/loading";

export interface Props {
  getTeams: Function;
  clearTeams: Function;
  teams: any;
  allTeams: any;
  quizData: any;
  user: any;
}

const Teams: React.FC<Props> = ({
  getTeams,
  clearTeams,
  teams,
  allTeams,
  quizData,
  user,
}) => {
  const [selectedTeam, setSelectedTeam] = useState<number | null>(null);
  const { quizId } = quizData;
  const { customerId } = user;

  const editTeam = (id: number) => {
    // console.log("edit team", id);
    setSelectedTeam(id);
  };

  useEffect(() => {
    if (allTeams.length === 0) {
      setLoading(true, "Loading Teams...");
      getTeams().then(() => setLoading(false));
    } else {
      getTeams();
    }
    //eslint-disable-next-line
  }, []);

  const sortByTeamName = (a: any, b: any) => {
    const nameA = a.teamName.toUpperCase(); // ignore upper and lowercase
    const nameB = b.teamName.toUpperCase();
    if (nameA < nameB) {
      return -1;
    }
    if (nameA > nameB) {
      return 1;
    }

    return 0;
  };

  // const refreshTeams = () => {
  //   setLoading(true, "Loading Teams...");
  //   getTeams().then(() => setLoading(false));
  // };

  // const removeTeams = () => {
  //   clearTeams();
  // };
  return (
    <>
      <AppHeader title="Teams" />
      <IonContent fullscreen className="ion-padding dashboard">
        <div className="container">
          <h2>Team List</h2>
          <IonList lines="full">
            {/* <>{console.log(teams.teams)}</> */}
            {teams.teams.sort(sortByTeamName).map((team: any, i: number) => (
              <IonItem
                key={i}
                button
                onClick={() => editTeam(team.teamId)}
                detail={true}
              >
                <IonLabel>
                  <span>{`(${team.teamId})`}</span> <span>{team.teamName}</span>
                </IonLabel>
                <IonLabel>
                  Players: {team.playerCount}
                  {/* {console.log(team)} */}
                </IonLabel>
              </IonItem>
            ))}
          </IonList>
          {allTeams.length > 0 && <AddTeamModal />}
          <EditTeamModal
            quizId={quizId}
            customerId={customerId}
            selected={selectedTeam}
            onClose={() => setSelectedTeam(null)}
          />
          {/* <IonButton onClick={refreshTeams}>
            DEV - Refresh All Teams List
          </IonButton>
          <IonButton onClick={removeTeams}>
            DEV - Remove all teams
          </IonButton> */}
        </div>
      </IonContent>
    </>
  );
};

const mapStateToProps = (state: any) => ({
  user: state.user.userDetails,
  quizData: state.quiz,
  teams: state.teams,
  allTeams: state.teams.allTeams,
});

export default connect(mapStateToProps, { getTeams, clearTeams })(Teams);
